import React from 'react'
import PropTypes from 'prop-types'
import withRouter from '../../lib/withRouter'
import Component from '../common/Component'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/AdminToolRuns'
import connectIndex from '../../lib/connectIndex'
import ArgumentsDisplay from './Helpers/ArgumentsDisplay'
import StatusDisplay from './Helpers/StatusDisplay'

export class AdminToolRunIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    records: PropTypes.array,
    pagination: PropTypes.object,
    flashMessages: PropTypes.array.isRequired,
    filterActions: PropTypes.object,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.object
  }

  static searchColumns = ['name']

  static defaultProps = {
    searchColumns: this.searchColumns
  }

  static columns = [
    {
      key: 'created_at',
      label: 'Created At',
      display: IndexComponent.dateTimeDisplay,
      filterable: false,
      sortable: false
    },
    {
      key: 'name',
      label: 'Name',
      filterable: true,
      sortable: false
    },
    {
      key: 'args',
      label: 'Arguments',
      display: ArgumentsDisplay,
      filterable: false,
      sortable: false
    },
    {
      key: 'username',
      label: 'User',
      filterable: false,
      sortable: false
    },
    {
      key: 'status',
      label: 'Status',
      display: StatusDisplay,
      filterable: false,
      sortable: false
    }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/admin_tool_runs"
          name="Admin Tool Logs"
          pagination={this.props.pagination}
          columns={AdminToolRunIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          filterActions={this.props.filterActions}
          searchPlaceholder="Search by Admin Tool Name"
          searchColumns={this.props.searchColumns}
          newRecordLinkTitle="New Admin Tool Run"
          history={this.props.history}
          actions={[]}
          filterable
        />
      </div>
    )
  }
}

export default connectIndex(withRouter(AdminToolRunIndex), 'adminToolRuns', actions)
